import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAqBN41QsMv5ZMJsJtCV-aLs2LiprnvHhg",
  authDomain: "notificaciones-fmg.firebaseapp.com",
  projectId: "notificaciones-fmg",
  storageBucket: "notificaciones-fmg.firebasestorage.app",
  messagingSenderId: "207783284522",
  appId: "1:207783284522:web:6cb9a470b564c5fbcb1853",
  measurementId: "G-80S2FJSN7S"
};

const app = initializeApp(firebaseConfig);

let messaging = null;
if ('serviceWorker' in navigator && 'PushManager' in window) {
  messaging = getMessaging(app);
} else {
  console.warn("⚠️ Este navegador no soporta Firebase Messaging");
}

export { messaging, getToken, onMessage };
